import Skeleton from "@mui/material/Skeleton";
import React from "react";
import {
  CardContainer,
  ImageContainer,
  OrgInformation,
  PostActions,
  PostDetails,
} from "./PostCard.styles";

export const FeedSkeletonCard: React.FC = () => (
  <CardContainer>
    <OrgInformation style={{ display: "flex", alignItems: "center" }}>
      <Skeleton variant="circular" width={35} height={35} />
      <div style={{ width: "100%", marginLeft: 16 }}>
        <Skeleton variant="text" height={18} width="40%" />
        <Skeleton variant="text" height={14} width="25%" />
      </div>
    </OrgInformation>

    <div style={{ padding: "0 25px" }}>
      <Skeleton variant="text" height={14} width="90%" />
      <Skeleton variant="text" height={14} width="80%" />
    </div>

    <ImageContainer>
      <Skeleton variant="rectangular" width="100%" height={450} />
    </ImageContainer>

    <PostDetails>
      <Skeleton variant="text" height={20} width="20%" />
      <Skeleton variant="text" height={20} width="20%" />
    </PostDetails>
    <div style={{ padding: "10px 0" }}>
      <PostActions>
        {[...Array(4)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width="22%"
            height={20}
            sx={{ borderRadius: "6px" }}
          />
        ))}
      </PostActions>
    </div>
  </CardContainer>
);
